import { render } from "./TradeCard.vue?vue&type=template&id=e88a1a80&scoped=true"
import script from "./TradeCard.vue?vue&type=script&lang=js"
export * from "./TradeCard.vue?vue&type=script&lang=js"

import "./TradeCard.vue?vue&type=style&index=0&id=e88a1a80&lang=scss&scoped=true"

import exportComponent from "G:\\Programming\\VueProjects\\radinrealp2p\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e88a1a80"]])

export default __exports__